import React from 'react';

const EmployerGrowContext = React.createContext({});

export default EmployerGrowContext;
